<template>
  <div class="mycoupons" v-if="showPage">
    <div v-show="showTake">
      <ul v-if="couponsList.length > 0">
        <li
          :class="item.coupon_property == 4 ? 'package' : ''"
          v-for="(item, index) in couponsList"
          :key="index"
        >
          <div class="property">
            {{ item.coupon_property_str }}
          </div>
          <p class="coupon-name">
            <span class="coupon-name-tit disabled">{{ item.name }}</span>
            <span class="coupon-name-pri" v-if="item.coupon_type != 5">
              <span class="money-icon" v-if="item.is_discount == 0">￥</span>
              {{ item.amount }}
              <span v-if="item.is_discount == 1">折</span>
            </span>
          </p>
          <p class="expiry-date disabled">
            <span class="fl">{{ item.finished_at }}</span>
            <span class="fr fs-20" v-if="item.coupon_type != 5">
              {{item.use_condition}}
            </span>
          </p>
          <p class="with-top-line">
            <span
              class="fl disabled"
              v-if="item.coupon_property == 4"
              >{{ item.package_limit }}</span
            >
            <span class="fl disabled" v-else>{{ item.description }}</span>
            <!-- <span class="fr use-btn" @click="toUseCoupon(item)">去使用</span> -->
          </p>
          <p
            class="use-rule"
            v-if="item.showPackageRule && item.coupon_property == 4"
            v-html="item.package_rule"
          ></p>
          <!-- 已使用 已过期 -->
          <div class="tag">
            <img v-if="item.status == 2" src="../assets/images/tag-coupon-used.png" style="width: 100%;"/>
            <img v-if="item.status == 3" src="../assets/images/tag-coupon-expried.png" style="width: 100%;"/>
          </div>
        </li>
      </ul>
      <div v-if="couponsList.length > 0" class="ac" style="padding: .3rem 0;color:#999">仅展示最近14天的过期优惠券</div>
      <div class="no-info" v-else>
        <div class="no-goods">
          <img src="../assets/images/empty-01.png" />
          <p>这里什么都没有</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { actions } from "../store/actions";
// import { MessageBox,Toast } from 'mint-ui'

export default {
  data() {
    return {
      showPage: false,
      couponsList: [],
      showTake: true,
      untakeCouponsList: [],
      showUntake: false,
      isShow: true,
      showContent: false,
      redeemCode: "",
      couponPackageList: [],
    };
  },
  computed: {
    schoolInfo() {
      return this.$store.state.schoolInfo;
    },
    wxLoginToken() {
      return this.$store.state.wxLoginToken;
    },
    openId() {
      return this.$store.state.openId;
    },
  },
  created() {
    var _this = this;
    // document.title = '我的优惠券'
    _this.getCouponList();
  },
  methods: {
    getCouponList: function () {
      var _this = this;
      var params2 = {
        token: _this.wxLoginToken,
        user_id: window.localStorage.getItem("wxUid"),
        school_id: _this.schoolInfo.schoolId,
        need_expire: 1
      };
      var params = {
        params: params2,
      };
      actions.PostCouponList(_this, params, function (data) {
        for (var i = 0; i < data.length; i++) {
          if (data[i].business === 10001 || data[i].business === "10001") {
            let coupon_property = data[i].coupon_property,
              coupon_property_str = "普通优惠";
            switch (coupon_property) {
              case 1:
                coupon_property_str = "普通优惠";
                break;
              case 2:
                coupon_property_str = "会员福利";
                break;
              case 3:
                coupon_property_str = "单单返现";
                break;
              case 4:
                coupon_property_str = `超值券包x${data[i].package_num}张`;
                break;
              case 7:
                coupon_property_str = "配送福利";
                break;
            }
            data[i].showPackageRule = false;
            data[i].coupon_property_str = coupon_property_str;
            if (data[i].package_rule) {
              data[i].package_rule = data[i].package_rule.replace(
                /(\n|\r|\r\n|↵)/g,
                "<br/>"
              );
            }
            _this.couponsList.push(data[i]);
          }
        }
        _this.showPage = true;
      });
    }
  },
};
</script>
<style scoped>
.redeem {
  margin-top: 0.2rem;
  padding: 0.22rem 0.32rem;
  height: 0.88rem;
  background-color: #fff;
}

.redeem span {
  font-size: 0.32rem;
  color: #ffdf00;
}

.redeem .input input {
  float: left;
  width: 60%;
}

.redeem .input input::placeholder {
  color: #999;
}

.redeem input {
  font-size: 0.28rem;
}
.cpackage-list {
  margin: 0.24rem 0.24rem 0 0.24rem;
}
.mycoupons .coupon-name-pri{
  color: #999;
}
.disabled{
  opacity: .5;
}
.mycoupons li .tag{
  position: absolute;
  width: .92rem;
  right: 0;
  bottom: 0;
}
</style>




// WEBPACK FOOTER //
// MyDisableCoupons.vue?bb5c3a1c